// add-free-gift.js
class AddFreeGift extends HTMLElement {
    constructor() {
        super();

        this.freeGiftProductId = parseInt(this.dataset.freeGiftProductId);
        this.includeFreeGift = this.dataset.includeFreeGift;

        if (this.includeFreeGift) {
            this.addFreeGift();
        } else {
            this.removeFreeGift();
        }
    }

    renderContents(parsedState) {
    }

    addFreeGift() {
        const body = JSON.stringify({
            updates: {
                [this.freeGiftProductId]: 1,
            }
        });

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                let parsedState = JSON.parse(state);
                this.renderContents(parsedState);
            })
            .catch(() => {
                console.error(e);
            });
    }

    removeFreeGift() {
        const body = JSON.stringify({
            updates: {
                [this.freeGiftProductId]: 0,
            }
        });

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                let parsedState = JSON.parse(state);
                this.renderContents(parsedState);
            })
            .catch(() => {
                console.error(e);
            })
    }
}
customElements.define("add-free-gift", AddFreeGift);
